import axios from 'axios'

import request from './request'

//https://opensky-network.org/api/states/all

/**
 * 获取实时全量航空器状态 (OpenSky Network API)
 * @returns {Promise}
 */
export function getRealTimeState() {
    return axios({
        url: 'https://opensky-network.org/api/states/all',
        method: 'get'
    })
}

/**
 * 获取指定日期的 ICAO 列表
 * @param {Object} params 
 * @param {string} params.date 日期格式 YYYY/MM/DD
 */
export function getICAOList(params) {
    const datePath = params.date.replace(/-/g, '/').replace(/\/+$/, '');
    return axios({
        url: `/adsb-proxy/traces/${datePath}/index.json`,
        method: 'get'
    })
}

/**
 * 获取指定 ICAO 的轨迹数据
 * @param {Object} params 
 * @param {string} params.date 日期格式 YYYY/MM/DD
 * @param {string} params.icao ICAO 码
 */
export function getTraceData(params) {
    const { date, icao } = params
    const datePath = date.replace(/-/g, '/').replace(/\/+$/, '');
    const icaoLower = icao.toLowerCase();
    // adsbexchange 轨迹文件路径规则：traces/YYYY/MM/DD/xx/trace_full_icao.json
    // 其中 xx 是 ICAO 码的最后两位
    const lastTwo = icaoLower.slice(-2);
    return axios({
        url: `/adsb-proxy/traces/${datePath}/${lastTwo}/trace_full_${icaoLower}.json`,
        method: 'get'
    })
}

/**
 * 获取指定时间的航空器状态数据 (gzip 压缩格式)
 * @param {Object} params 
 * @param {string} params.time 时间戳，格式如 '235955Z' (DDHHMMSZ 格式)
 * @returns {Promise}
 */
export function getAircraftStateData(params) {
    const { time } = params
    return axios({
        url: `json/${time}.cn.json`,
        method: 'get'
    })
}

//+++++++++++++++
//查询接收机最近30分钟内接收到的所有的飞机的最后位置 
// GET /location/adsbLocation
export function getAdsbLocation(data) {
    return request({
        url: '/location/adsbDevice',
        method: 'get',
        params: data
    })
}


//根据icao查询某个飞机24小时内轨迹 
// GET   /location/adsbLocation?icao=780CC1   
export function getAdsbLocationGJ(data) {
    return request({
        url: '/location/adsbLocation',
        method: 'get',
        params: data
    })
}

